import Schema from 'validate';
import isEmail from 'validator/lib/isEmail';

import PersonSchema from '../../../../lib/paths/person_FULL_Paths.json';
const P = PersonSchema.attributes;

const mailValidator = (val: string) => isEmail(val);

const PersonDatenValidator = new Schema({
	[P.Personenbezogene_Daten_Anrede.path]: { type: String },
	[P.Personenbezogene_Daten_Titel.path]: {
		type: String,
	},
	[P.Personenbezogene_Daten_Vorname.path]: {
		type: String,
		required: true,
	},
	[P.Personenbezogene_Daten_Nachname.path]: {
		type: String,
		required: true,
	},
	[P.Kontaktdaten_E_Mail.path]: {
		type: String,
		required: true,
		use: { mailValidator },
		message: {
			mailValidator: 'Ungültige E-Mail-Adresse.',
		},
	},
	[P.Kontaktdaten_Telefon.path]: {
		type: String,
		required: true,
		use: {
			phone: (val: string) => /^[0-9\s]*$/.test(val),
		},
		message: {
			phone: 'Diese Telefonnummer ist ungültig. Es sind nur Zahlen und Leerzeichen erlaubt.',
		},
	},
});

PersonDatenValidator.message({
	required: (_path: string) => 'Dies ist ein Pflichtfeld',
	type: (path: string) => `Das Formular ist fehlerhaft, bitte melden Sie diesen Felder. Geben Sie als Grund "falscher Datantyp, ${path}" an`,
});

export default PersonDatenValidator;
